<div *ngIf="isAdmin" class="flx-container">
  <div class="flx-item title">Who are you scheduling this site visit for?</div>

  <div class="flx-break"></div>

  <div class="flx-item">
    <button class="btn btn-primary btn-round hvr-push" (click)="onSelfClick()">Myself</button>
    <button class="btn btn-primary btn-round hvr-push" (click)="onOtherClick()">Someone Else</button>
  </div>
</div>

<div class="error-text" *ngIf="!isAdmin">You are not authorized to view this page.</div>
